/**
 * Extracts the hospital_staff IDs of HCPs tagged in a note's HTML content.
 *
 * Quill's mention module emits spans of the form:
 *   <span class="mention" data-id="42" data-value="email@example.com">...</span>
 *
 * The HTML is the source of truth for who is currently tagged: parsing it on save
 * keeps the tag list and the rendered text in lock-step (no separate state to drift).
 */
export function extractTaggedHcpIds(html: string): number[] {
  if (!html) {
    return [];
  }

  const doc = new DOMParser().parseFromString(html, "text/html");
  const mentions = doc.querySelectorAll("span.mention[data-id]");
  const ids = new Set<number>();

  mentions.forEach((span) => {
    const raw = span.getAttribute("data-id");
    if (!raw) return;
    const id = Number(raw);
    if (Number.isFinite(id) && id > 0) {
      ids.add(id);
    }
  });

  return Array.from(ids);
}
